// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../revvComponents";

// Internal Imports
import { DRAFT } from "../../constants";
import {
  checkBlockTypeBtnStatus,
  getMarginFromListLevel,
  getListLevelFromMargin,
} from "../../utils/draftUtils";

// Destructuring
const { TOOLBAR_LIST_BUTTONS } = DRAFT;

class ListButtons extends Component {
  _onToggle = (event, newListType) => {
    event.preventDefault();
    if (this.props.activeToolbarDropDown) {
      this.props.toogleToolbarDropDown(null);
    }
    const oldListType = this._getBlockType(this.props.editorState);
    let decideType = newListType;
    let marginLeft = "";
    // Check if new and old list types are same then, make it normal text,
    // otherwise make it new list
    if (
      oldListType &&
      newListType &&
      ((oldListType.startsWith("ordered-list") &&
        newListType.startsWith("ordered-list")) ||
        (oldListType.startsWith("unordered-list") &&
          newListType.startsWith("unordered-list")))
    ) {
      const listLevel = parseInt(oldListType.split("-")[2], 10);
      marginLeft = getMarginFromListLevel(listLevel);
      decideType = "unstyled";
    } else {
      decideType = this._decideListType(this.props.editorState, newListType);
    }
    this.props.handleListButton(decideType, oldListType, marginLeft);
  };

  _decideListType = (editorState, newListType) => {
    let decideType = newListType;
    const contentState = editorState.getCurrentContent();
    const selectionState = editorState.getSelection();
    const startKey = selectionState.getStartKey();
    const startBlock = contentState.getBlockForKey(startKey);
    const blockData = startBlock.data;
    const elementStyle = blockData.get("elementStyle");
    const styles =
      typeof elementStyle === "string" ? elementStyle.split(";") : [];
    const marginLeftIndex = styles.findIndex(style =>
      style.startsWith("margin-left"),
    );
    // if already has indent then decide list level based on indent
    if (marginLeftIndex > -1) {
      const marginCount = parseInt(
        styles[marginLeftIndex].split(":")[1].trim().slice(0, -2),
        10,
      );
      decideType = getListLevelFromMargin(marginCount, decideType);
    }

    return decideType;
  };

  _getBlockType = editorState => {
    if (editorState) {
      const selectionState = editorState.getSelection();
      const currentContent = editorState.getCurrentContent();
      const startKey = selectionState.getStartKey();
      const endKey = selectionState.getEndKey();
      const blocks = currentContent.getBlocksAsArray();
      const startIndex = blocks.findIndex(block => block.getKey() === startKey);
      const endIndex = blocks.findIndex(block => block.getKey() === endKey);
      const selectedBlocks = blocks.slice(startIndex, endIndex + 1);
      let selectedBlockTypes = [];
      if (selectedBlocks && selectedBlocks.length > 0) {
        selectedBlockTypes = selectedBlocks.map(block => block.type);
      }
      const allEqual = selectedBlockTypes.every(
        blockType => blockType === selectedBlockTypes[0],
      );
      return allEqual ? selectedBlockTypes[0] : "";
    }
    return "";
  };

  onWindowClick = () => {
    this.props.onOverrideContent(undefined);
  };

  render() {
    return TOOLBAR_LIST_BUTTONS.map(btn => {
      let className = "draftJsToolbar__button__qi1gf normal-text-button ";
      if (checkBlockTypeBtnStatus(this.props.editorState, btn.id)) {
        className += btn.activeClass;
      }
      return (
        <div
          className="draft-edit-items"
          id={btn.toolbarID}
          key={btn.toolbarID}>
          <div className="draftJsToolbar__buttonWrapper__1Dmqh">
            <Tooltip
              placement="top"
              overlay={btn.tooltip}
              align={{
                offset: [3, 0],
              }}>
              <button
                data-test="revvtoolbar-list-button"
                type="button"
                className={className}
                onMouseDown={event => this._onToggle(event, btn.type)}>
                <FontAwesomeIcon icon={["fas", `${btn.icon}`]} />
              </button>
            </Tooltip>
          </div>
        </div>
      );
    });
  }
}

export default ListButtons;
